export const MOCK_SURVEY: API.NPS.Survey = {
  uuid: "s1",
  name: "Customer Satisfaction Survey",
  questions: [
    {
      uuid: "q1",
      text: "How likely are you to recommend Aqua to a friend or colleague?",
      is_required: true,
      answer_type: "npsscore",
      answer_choices: {
        uuid: "choices-uuid",
        choices: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      },
    },
    {
      uuid: "q2",
      text: "What is the primary reason for your score?",
      is_required: true,
      answer_type: "freeformtext",
      answer_choices: null,
    },
    {
      uuid: "q3",
      text: "What could we do to improve our service?",
      is_required: false,
      answer_type: "freeformtext",
      answer_choices: null,
    },
  ],
};

export const MOCK_IMPRESSION: API.NPS.RecordImpression.Response = {
  uuid: "i1",
  survey: "s1",
  viewed_at: "2025-10-17T12:34:56.789012Z",
};

export const MOCK_ANSWER: API.NPS.SubmitAnswers.Response = {
  success: true,
};

export const MOCK_SURVEY_BAD_DATA: API.NPS.Survey = {
  uuid: "s1",
  name: "Customer Satisfaction Survey",
  questions: [
    {
      uuid: "q1",
      text: "How likely are you to recommend Aqua to a friend or colleague?",
      is_required: false,
      answer_type: "npsscore",
      answer_choices: null,
    },
  ],
};
